import _styled from "@emotion/styled-base";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
import PropTypes from "prop-types";

import { rem } from "polished";

var LabelComponent = /*#__PURE__*/_styled("label", {
  target: "eeb25ip0",
  label: "LabelComponent"
})("display:inline-block;font-size:", rem(14), ";font-weight:", function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeight.regular;
}, ";color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.gray500;
}, ";line-height:1.5;", function (_ref3) {
  var required = _ref3.required,
      theme = _ref3.theme;
  return required && "\n    &::after {\n      content: \"*\";\n      color: " + theme.colors.danger + ";\n    }\n  ";
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0xhYmVsL0xhYmVsLmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFLc0MiLCJmaWxlIjoiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvTGFiZWwvTGFiZWwuanN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tIFwicHJvcC10eXBlc1wiO1xuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCI7XG5pbXBvcnQgeyByZW0gfSBmcm9tIFwicG9saXNoZWRcIjtcblxuY29uc3QgTGFiZWxDb21wb25lbnQgPSBzdHlsZWQoXCJsYWJlbFwiKWBcbiAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuICBmb250LXNpemU6ICR7cmVtKDE0KX07XG4gIGZvbnQtd2VpZ2h0OiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmZvbnRXZWlnaHQucmVndWxhcn07XG4gIGNvbG9yOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmNvbG9ycy5ncmF5NTAwfTtcbiAgbGluZS1oZWlnaHQ6IDEuNTtcbiAgJHsoeyByZXF1aXJlZCwgdGhlbWUgfSkgPT5cbiAgICByZXF1aXJlZCAmJlxuICAgIGBcbiAgICAmOjphZnRlciB7XG4gICAgICBjb250ZW50OiBcIipcIjtcbiAgICAgIGNvbG9yOiAke3RoZW1lLmNvbG9ycy5kYW5nZXJ9O1xuICAgIH1cbiAgYH1cbmA7XG5cbmNvbnN0IExhYmVsID0gKHsgcmVxdWlyZWQsIC4uLnByb3BzIH0pID0+IChcbiAgPExhYmVsQ29tcG9uZW50IHJlcXVpcmVkPXtyZXF1aXJlZH0gey4uLnByb3BzfSAvPlxuKTtcblxuTGFiZWwucHJvcFR5cGVzID0ge1xuICAvKipcbiAgICogQWRkICogY2hhcmFjdGVyIGlmIGlzIGEgcmVxdWlyZWQgZmllbGQuXG4gICAqL1xuICByZXF1aXJlZDogUHJvcFR5cGVzLmJvb2xcbn07XG5cbkxhYmVsLmRlZmF1bHRQcm9wcyA9IHtcbiAgcmVxdWlyZWQ6IGZhbHNlXG59O1xuXG5leHBvcnQgZGVmYXVsdCBMYWJlbDtcbiJdfQ== */");

var Label = function Label(_ref4) {
  var required = _ref4.required,
      props = _objectWithoutProperties(_ref4, ["required"]);

  return React.createElement(LabelComponent, _extends({ required: required }, props));
};

Label.propTypes = {
  /**
   * Add * character if is a required field.
   */
  required: PropTypes.bool
};

Label.defaultProps = {
  required: false
};

export default Label;